import { AgencyFragment } from '@gql'
import { createModel } from '../../../store/generic'

export default createModel<AgencyFragment>()
